import { render, staticRenderFns } from "./DetailRiwayatWithdrawal.vue?vue&type=template&id=0b535703&scoped=true&"
import script from "./DetailRiwayatWithdrawal.vue?vue&type=script&lang=js&"
export * from "./DetailRiwayatWithdrawal.vue?vue&type=script&lang=js&"
import style0 from "./DetailRiwayatWithdrawal.vue?vue&type=style&index=0&id=0b535703&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b535703",
  null
  
)

export default component.exports